import contactsApi from '@modules/contacts/api'
import { useQuery } from '@tanstack/react-query'

export const useContactHistory = (enabled: boolean, data: { onlyMine?: boolean; exclude?: boolean; hasAttended?: boolean }) => {
  /**
   * type is a quick fix for now, ideally we need to re-architecture
   * to support type from the whole feature instead of onlyMine and exclude.
   */
  let type = 'COMPANY'
  if (data.onlyMine) {
    type = 'MINE'
  } else if (data.exclude) {
    type = 'NONE'
  }

  const { data: companyIds } = useQuery({
    queryKey: [contactsApi.getContactIds.key, type, data.hasAttended],
    queryFn: () => contactsApi.getContactIds.fn({ type, hasAttended: data.hasAttended }),
    enabled,
  })

  return companyIds as number[]
}
